{
  "el": {
    "subscription": {
      "customers": {
        "announcement": {
          "description": "Λάβε ειδοποίηση με τη δημοσίευση νέων ανακοινώσεων.",
          "label": "Ανακοινώσεις"
        },
        "question": {
          "description": "Λάβε ειδοποίηση όταν προστίθενται νέες ερωτήσεις στην ενότητα FAQ.",
          "label": "FAQ"
        }
      },
      "employees": {
        "aftercare": {
          "description": "Λάβε ειδοποιήσεις σχετικά με τις παρατηρήσεις.",
          "label": "Παρατηρήσεις"
        },
        "announcement": {
          "description": "Λάβε ειδοποίηση με τη δημοσίευση νέων ανακοινώσεων.",
          "label": "Ανακοινώσεις"
        },
        "decision": {
          "description": "Λάβε ειδοποιήσεις σχετικά με τις αποφάσεις.",
          "label": "Αποφάσεις"
        },
        "document": {
          "description": "Λάβε ειδοποίηση με το ανέβασμα νέων εγγράφων.",
          "employee_create": {
            "description": "Λάβε ειδοποίηση με το ανέβασμα εγγράφων από άλλους υπαλλήλους.",
            "label": "Έγγραφα από συναδέλφους"
          },
          "label": "Έγγραφα"
        },
        "email_conversation": {
          "description": "Λάβε ειδοποίηση όταν προωθούνται email στα έργα σου στο Ziggu.",
          "label": "Προώθηση email"
        },
        "export": {
          "description": "Λάβε ειδοποίηση όταν δημιουργούνται εξαγωγές.",
          "label": "Εξαγωγές"
        },
        "question": {
          "description": "Λάβε ειδοποίηση όταν προστίθενται νέες ερωτήσεις στην ενότητα FAQ.",
          "label": "FAQ"
        },
        "survey": {
          "description": "Λάβε ειδοποιήσεις σχετικά με τα ερωτηματολόγια.",
          "label": "Ερωτηματολόγια"
        },
        "ticket": {
          "description": "Λάβε ειδοποιήσεις σχετικά με τις συνομιλίες.",
          "label": "Συνομιλίες"
        },
        "todo": {
          "description": "Λάβε ειδοποίηση όταν σου ανατεθεί μια εργασία.",
          "label": "Αναθέσεις εργασιών"
        }
      },
      "labels": {
        "email_preferences": "Οι προτιμήσεις μου για ειδοποιήσεις email",
        "general_preferences": "Οι προτιμήσεις μου για ειδοποιήσεις",
        "receiveEmailNotificationsAbout": "Λήψη ειδοποιήσεων email"
      }
    }
  }
}
